import { render } from "./Add.vue?vue&type=template&id=6ebafb0c&scoped=true"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"

import "./Add.vue?vue&type=style&index=0&id=6ebafb0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ebafb0c"]])

export default __exports__